import { render, staticRenderFns } from "./FilterBoardTypes.vue?vue&type=template&id=67da14b6&scoped=true"
import script from "./FilterBoardTypes.vue?vue&type=script&lang=js"
export * from "./FilterBoardTypes.vue?vue&type=script&lang=js"
import style0 from "./FilterBoardTypes.vue?vue&type=style&index=0&id=67da14b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67da14b6",
  null
  
)

export default component.exports